import { Box, Button, styled, Typography } from '@mui/material';
import { MediaQueryProps } from '../types';

export const HeroSection = styled(Box)`
  padding: 0;
`;

export const HeroHeader = styled(Box)`
  display: flex;
  flex-direction: row;
  align-items: baseline;
  justify-content: space-between;
`;

export const HeroImage = styled('img', {
  shouldForwardProp: (prop: string) => !['islaptop', 'iswidescreen'].includes(prop),
})<MediaQueryProps>`
  height: 200px;
  padding-left: 40px;
  display: ${({ islaptop }) => (islaptop ? 'none' : 'initial')};
`;

export const HeroTitle = styled(Typography)`
  font-weight: 700;
  color: ${({ theme }) => theme.palette.text.primary};
`;

export const HeroBody = styled(Box)`
  padding-top: 30px;
  padding-bottom: 40px;
  text-align: justify;
`;

export const HeroButtonContainer = styled(Box, {
  shouldForwardProp: (prop: string) => prop !== 'islaptop',
})<MediaQueryProps>`
  display: flex;
  flex-direction: ${({ islaptop }) => (islaptop ? 'column' : 'row')};
  align-items: center;
  justify-content: center;
  gap: ${({ islaptop }) => (islaptop ? '20px' : '40px')};
`;

export const HeroButton = styled(Button)`
  background-color: ${({ theme }) => theme.palette.primary.main};
  font-weight: 600;
  padding: 8px 22px;
`;
